











import { Vue, Component, Prop } from "vue-property-decorator";
import { ILead } from "@/models/leads";

@Component({
  components: {
    "lead-search": () => import("@/components/app/admin/leads/leadSearch.vue")
  }
})
export default class SelectLeadModal extends Vue {
  // Props
  @Prop({ default: () => ({}) })
  public lead!: ILead;
  @Prop({
    required: false,
    default: () => []
  })
  public excludedLeadsIds!: ILead["id"][];
}
